import React from 'react';
import { Box, Button, Grid, Image, Modal, Select, TextField, Typography } from '@iho-design-system/Loader';

import EditSVG from '../../../assets/images/icons/edit.svg';
import EmptySVG from '../../../assets/images/icons/empty.svg';
import LoadingCustomSVG from '../../../assets/images/icons/loading-custom.svg';
import TrashbinSVG from '../../../assets/images/icons/trashbin.svg';

import get from '../../../api/get';
import post from '../../../api/post';

const bankNameList = [
  '',
  'بانک ملّی ایران',
  'بانک اقتصاد نوین',
  'بانک قرض‌الحسنه مهر ایران',
  'بانک سپه',
  'بانک پارسیان',
  'بانک قرض‌الحسنه رسالت',
  'بانک صنعت و معدن',
  'بانک کارآفرین',
  'بانک کشاورزی',
  'بانک سامان',
  'بانک مسکن',
  'بانک سینا',
  'بانک توسعه صادرات ایران',
  'بانک خاورمیانه',
  'بانک توسعه تعاون',
  'بانک شهر',
  'پست بانک ایران',
  'بانک دی',
  'بانک صادرات',
  'بانک ملت',
  'بانک تجارت',
  'بانک رفاه',
  'بانک حکمت ایرانیان',
  'بانک گردشگری',
  'بانک ایران زمین',
  'بانک قوامین',
  'بانک انصار',
  'بانک سرمایه',
  'بانک پاسارگاد'
];

const initialEditState = {
  id: '',
  accountName: { value: '', color: 'dark' },
  cardNumber: { value: '', color: 'dark' },
  bankName: { value: '', color: 'dark' },
  bankAccount: { value: '', color: 'dark' },
  sheba: { value: '', color: 'dark' }
};

const List = ({ props, alertProps, reloadFinanceProps }) => {
  const [bankAccount, setBankAccount] = React.useState('loading');
  const [editParams, setEditParams] = React.useState(initialEditState);
  const [removeParams, setRemoveParams] = React.useState({
    id: '',
    accountName: '',
    bankName: ''
  });

  React.useEffect(() => {
    if (!props.bankAccount) return;
    if (props.bankAccount.status === 200 && props.bankAccount.data.length > 0) {
      setBankAccount(props.bankAccount.data);
    } else {
      setBankAccount('empty');
    }
  }, [props]);

  const updateField = (key, value, isValid) => {
    setEditParams(prev => ({
      ...prev,
      [key]: {
        value,
        color: isValid ? 'dark' : 'danger'
      }
    }));
  };

  const editHandler = (key, value) => {
    if (key === 'accountName') updateField(key, value, value !== '');
    if (key === 'cardNumber') updateField(key, value, value !== '' && value.length === 16);
    if (key === 'bankName') updateField(key, value, value !== '');
    if (key === 'bankAccount') updateField(key, value, value !== '');
    if (key === 'sheba') updateField(key, value, value !== '' && value.length === 24);
  };

  const validateEdit = () => {
    let valid = true;
    Object.entries(editParams).forEach(([key, obj]) => {
      if (key === 'id') return;
      let condition = obj.value !== '';
      if (key === 'cardNumber') condition = obj.value.length === 16;
      if (key === 'sheba') condition = obj.value.length === 24;
      if (!condition) {
        valid = false;
        updateField(key, obj.value, false);
      }
    });
    return valid;
  };

  const editBankAccount = async () => {
    if (!validateEdit()) return;

    const body = {
      Id: editParams.id,
      AccountName: editParams.accountName.value,
      CardNumber: editParams.cardNumber.value,
      BankName: editParams.bankName.value,
      bankAccount: editParams.bankAccount.value,
      Sheba: editParams.sheba.value
    };

    const result = await post({
      ctrl: 'Bankaccount',
      method: 'Edit',
      query: editParams.id,
      body
    });

    if (result.status === 200) {
      alertProps(['success', 'با موفقیت انجام شد']);
      reloadFinanceProps(Math.random());
      closeEditModal();
    } else {
      alertProps(['danger', result.data.Message]);
    }

    setEditParams(initialEditState);
  };

  const removeBankAccount = async () => {
    const result = await get({
      ctrl: 'Bankaccount',
      method: 'Delete',
      query: removeParams.id
    });

    if (result.status === 200) {
      alertProps(['success', 'با موفقیت انجام شد']);
      reloadFinanceProps(Math.random());
      closeRemoveModal();
    } else {
      alertProps(['danger', result.data.Message]);
    }
  };

  const openEditModal = (item) => {
    document.querySelector('.editBankAccount').classList.remove('d-none');
    setEditParams({
      id: item.Id,
      accountName: { value: item.AccountName, color: 'dark' },
      cardNumber: { value: item.CardNumber, color: 'dark' },
      bankName: { value: item.BankName, color: 'dark' },
      bankAccount: { value: item.BankAccount, color: 'dark' },
      sheba: { value: item.Sheba, color: 'dark' }
    });
  };

  const closeEditModal = () => {
    document.querySelector('.editBankAccount').classList.add('d-none');
  };

  const openRemoveModal = (item) => {
    document.querySelector('.removeBankAccountModal').classList.remove('d-none');
    setRemoveParams({
      id: item.Id,
      accountName: item.AccountName,
      bankName: item.BankName
    });
  };

  const closeRemoveModal = () => {
    document.querySelector('.removeBankAccountModal').classList.add('d-none');
  };

  if (bankAccount === 'loading') {
    return (
      <Image className="d-block mx-auto" src={LoadingCustomSVG} ms={{ width: 40, height: 40 }} />
    );
  }

  if (bankAccount === 'empty') {
    return (
      <Box>
        <Image className="mx-auto" src={EmptySVG} ms={{ display: 'block', width: 120, height: 120 }} />
        <Typography className="d-block text-center" component="h2">
          لیست حساب‌ های بانکی شما خالی است :(
        </Typography>
        <Box className="my-md" />
        <Typography className="d-block text-center" component="strong">
          لیست حساب‌ های بانکی شما خالی است :(
        </Typography>
      </Box>
    );
  }

  return (
    <>
      <Grid>
        <Grid.Wrapper>
          <Grid.Item size="col-12">
            <Box ms={{ '@media(max-width:992px)': { overflowX: 'scroll' } }}>
              <Box ms={{ minWidth: '992px' }}>
                <Box className="d-inline-block w-100 my-sm mt-0 px-xl py-lg rounded-sm" ms={{ backgroundColor: 'var(--gray-light)' }}>
                  {['نام صاحب حساب', 'شماره حساب', 'شماره کارت', 'شماره شبا'].map((title, i) => (
                    <Box key={i} className="d-inline-block" ms={{ width: '20%' }}>
                      <Typography>{title}</Typography>
                    </Box>
                  ))}
                </Box>

                <Box className="border-solid border-light rounded-sm" ms={{ backgroundColor: 'var(--white)' }}>
                  {bankAccount.map((obj, index) => (
                    <Box key={index} className="d-flex justify-content-between px-lg py-md border-solid-bottom border-light">
                      <Box ms={{ width: '20%' }}>{obj.AccountName}</Box>
                      <Box ms={{ width: '20%' }}>{obj.BankAccount}</Box>
                      <Box ms={{ width: '20%', whiteSpace: 'nowrap' }}>
                        {obj.CardNumber.toString().replace(/\B(?=(\d{4})+(?!\d))/g, '-')}
                      </Box>
                      <Box ms={{ width: '20%', whiteSpace: 'nowrap' }}>IR-{obj.Sheba}</Box>
                      <Box className="d-flex justify-content-end" ms={{ width: '20%' }}>
                        <Image onClick={() => openRemoveModal(obj)} className="pointer" src={TrashbinSVG} ms={{ width: 16, height: 16 }} />
                        <Box className="mx-sm" />
                        <Image onClick={() => openEditModal(obj)} className="pointer" src={EditSVG} ms={{ width: 16, height: 16 }} />
                      </Box>
                    </Box>
                  ))}
                </Box>
              </Box>
            </Box>
          </Grid.Item>
        </Grid.Wrapper>
      </Grid>

      <Modal className="editBankAccount">
        <Modal.Wrapper size="xs">
          <Modal.Header className="border-solid-bottom border-light">
            ویرایش حساب بانکی
            <Box />
          </Modal.Header>

          <Box className="p-sm">
            <Grid>
              <Grid.Wrapper>
                <Grid.Item size="col-12">
                  <TextField
                    label="نام صاحب حساب"
                    value={editParams.accountName.value}
                    color={editParams.accountName.color}
                    onChange={e => editHandler('accountName', e)}
                  />
                </Grid.Item>
                <Grid.Item size="col-6">
                  <TextField
                    label="شماره کارت"
                    value={editParams.cardNumber.value}
                    color={editParams.cardNumber.color}
                    onChange={e => editHandler('cardNumber', e)}
                  />
                </Grid.Item>
                <Grid.Item size="col-6">
                  <Select
                    label="نام بانک"
                    init={editParams.bankName.value}
                    color={editParams.bankName.color}
                    onChange={e => editHandler('bankName', e)}
                    search
                  >
                    {bankNameList.filter(Boolean).map((b, i) => (
                      <Select.Item key={i} value={b}>{b}</Select.Item>
                    ))}
                  </Select>
                </Grid.Item>
                <Grid.Item size="col-6">
                  <TextField
                    label="شماره حساب"
                    value={editParams.bankAccount.value}
                    color={editParams.bankAccount.color}
                    onChange={e => editHandler('bankAccount', e)}
                  />
                </Grid.Item>
                <Grid.Item size="col-6">
                  <TextField
                    label="شماره شبا"
                    value={editParams.sheba.value}
                    color={editParams.sheba.color}
                    onChange={e => editHandler('sheba', e)}
                  />
                </Grid.Item>
                <Grid.Item size="col-12" className="d-flex">
                  <Button onClick={editBankAccount} color="primary">تایید</Button>
                  <Box className="mx-sm" />
                  <Button onClick={closeEditModal} variant="outlined" color="danger">انصراف</Button>
                </Grid.Item>
              </Grid.Wrapper>
            </Grid>
          </Box>
        </Modal.Wrapper>
      </Modal>

      <Modal className="removeBankAccountModal">
        <Modal.Wrapper size="xs">
          <Modal.Header className="border-solid-bottom border-light">
            حذف حساب بانکی
            <Box />
          </Modal.Header>

          <Box className="p-sm">
            <Typography>
              آیا حذف حساب انتخاب شده ({removeParams.accountName} - {removeParams.bankName}) را تایید می نمایید؟
            </Typography>
            <Box className="d-flex mt-md">
              <Button onClick={removeBankAccount} color="primary">تایید</Button>
              <Box className="mx-sm" />
              <Button onClick={closeRemoveModal} variant="outlined" color="danger">انصراف</Button>
            </Box>
          </Box>
        </Modal.Wrapper>
      </Modal>
    </>
  );
};

export default List;
